"use client";
import React, { useState, useEffect, useRef } from "react";

import MatchHistoryItem from "./MatchHistoryItem";
import MatchHistoryHeader from "./MatchHistoryHeader";

const MatchHistoryTable = ({ matches, isHalftimeChecked, isHome }) => {
  const tableContainerRef = useRef(null);
  const fakeScrollRef = useRef(null);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [fakeScrollWidth, setFakeScrollWidth] = useState(0);
  const [fakeScrollPosition, setFakeScrollPosition] = useState(0);
  const [isShowScroll, setIsShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (tableContainerRef.current) {
        const container = tableContainerRef.current;
        const scrollWidth = container.scrollWidth;
        const clientWidth = container.clientWidth;
        
        // Check if content is wider than container
        if (scrollWidth > clientWidth) {
          setIsShowScroll(true);
          
          if (fakeScrollRef.current) {
            const fakeScroll = fakeScrollRef.current;
            
            // Calculate scroll thumb width
            const scrollThumbWidth = (clientWidth / scrollWidth) * clientWidth;
            
            // Calculate fake scroll position
            const scrollLeftFake = scrollLeft / scrollWidth * fakeScroll.scrollWidth;
            
            setFakeScrollWidth(scrollThumbWidth);
            setFakeScrollPosition(scrollLeftFake);
          }
        } else {
          setIsShowScroll(false);
        }
      }
    };

    // Check immediately
    checkScroll();
    
    // Check on resize
    const handleResize = () => {
      setTimeout(checkScroll, 100); // Small delay to ensure DOM updates
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [scrollLeft]);

  const syncScroll = () => {
    if (tableContainerRef.current) {
      setScrollLeft(tableContainerRef.current.scrollLeft);
    }
  };
  
  return (
    <div className="relative">
      <div ref={tableContainerRef}
        onScroll={syncScroll}
        className={"w-full overflow-x-scroll overflow-y-hidden scrollable"}
        style={{
          overflowX: "scroll",
          scrollbarWidth: "none", /* For Firefox */
          msOverflowStyle: "none", /* For Internet Explorer */
          minWidth: "100%",
          maxWidth: "100%"
        }}
      >
        <div className="min-w-[816px] max-lg:min-w-[816px]">
          <MatchHistoryHeader isHome={isHome} />

          <div
            className={
              "flex flex-col justify-center items-center gap-1 w-full mt-1"
            }
          >
            {matches.map((match, index) => (
              <MatchHistoryItem key={index} match={match} isHalftimeChecked={isHalftimeChecked} />
            ))}
          </div>
        </div>
        <style>
          {`
      div::-webkit-scrollbar {
        display: none; /* For WebKit */
      }
    `}
        </style>
      </div>
      {/* Fake horizontal scrollbar */}
      {isShowScroll && (
        <div
          ref={fakeScrollRef}
          className="bg-[#FFFFFF] h-1.5 mt-1 rounded-[5px]"
          style={{
            position: "absolute",
            bottom: "-15px",
            left: "50%",
            width: "90%", 
            backgroundColor: "#d1d5db",
            overflow: "hidden",
            transform: "translate(-50%, -50%)"
          }}
        >
          <div
            className="bg-[#D9D9D9] h-1.5 rounded-[5px]"
            style={{
              width: `${fakeScrollWidth}px`, 
              transform: `translateX(${fakeScrollPosition}px)`,
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default MatchHistoryTable;
